import styled, { css } from 'styled-components'

import { Button } from 'common-components'
import { COLORS } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import SlideUp from 'common-components/SlideUp'

export const ExportButtonWrapper = styled(Button)<{ $isDisabled: boolean }>`
  margin-right: 24px;
  word-break: keep-all;
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
    `};
`

export const ExportDropdownContent = styled.div`
  background: ${COLORS.white};
  border-radius: ${RADII.card};
  width: 320px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: ${SHADOWS.menu};
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    box-shadow: none;
  }
`

export const ExportOptionsSlideUp = styled(SlideUp)`
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    z-index: 9999;
  }
`
